/**
 * Mascot rendering utilities for Fun Old Times
 * Centralized mascot components for reuse across the application
 * All SVG content is externalized to reduce file size
 */

/**
 * Renders a miniature Party Panda mascot with party hat
 * @returns {string} HTML string with img tag
 */
export function renderTinyPartyPanda() {
  return `
    <img 
      src="/frontend/images/mascots/tiny-party-panda.svg" 
      alt="Tiny Party Panda" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders the Society Otter mascot
 * @returns {string} HTML string with img tag
 */
export function renderSocietyOtter() {
  return `
    <img 
      src="/frontend/images/mascots/social-otter.svg" 
      alt="Society Otter" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Tiny Society Otter for toolbars (same asset, scaled by layout CSS).
 * @returns {string} HTML string with img tag
 */
export function renderTinySocietyOtter() {
  return renderSocietyOtter();
}

/**
 * Renders a Party Panda mascot with confetti
 * @returns {string} HTML string with img tag
 */
export function renderPartyPanda() {
  return `
    <img 
      src="/frontend/images/mascots/party-panda.svg" 
      alt="Party Panda" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders a Party Panda with megaphone (for reminders/announcements)
 * @returns {string} HTML string with img tag
 */
export function renderPartyPandaMegaphone() {
  return `
    <img 
      src="/frontend/images/mascots/party-panda-megaphone.svg" 
      alt="Party Panda with Megaphone" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders a Disco Capybara mascot
 * @returns {string} HTML string with img tag
 */
export function renderDiscoCapybara() {
  return `
    <img 
      src="/frontend/images/mascots/disco-capybara.svg" 
      alt="Disco Capybara" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders a Safety Armadillo mascot
 * @returns {string} HTML string with img tag
 */
export function renderSafetyArmadillo() {
  return `
    <img 
      src="/frontend/images/mascots/safety-armadillo.svg" 
      alt="Safety Armadillo" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders a Taco UFO mascot
 * @returns {string} HTML string with img tag
 */
export function renderTacoUFO() {
  return `
    <img 
      src="/frontend/images/mascots/taco-ufo.svg" 
      alt="Taco UFO" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders the Gossip Goose mascot
 * @returns {string} HTML string with img tag
 */
export function renderGossipGoose() {
  return `
    <img 
      src="/frontend/images/mascots/gossip-goose.svg" 
      alt="Gossip Goose" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}

/**
 * Renders the Missing Mole mascot for unknown file types
 * @returns {string} HTML string with img tag
 */
export function renderMissingMole() {
  return `
    <img 
      src="/frontend/images/mascots/missing-mole.svg" 
      alt="Missing Mole - Unknown file type" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
